webpackJsonp([114276838955818],{

/***/ 140:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Phanor Coll - Fullstack Developer","author":"Phanor Coll","description":"gopher in action"}}},"layoutContext":{}}

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(311);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(140);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _linuxLogo = __webpack_require__(204);
	
	var _linuxLogo2 = _interopRequireDefault(_linuxLogo);
	
	var _coffeeCup = __webpack_require__(70);
	
	var _coffeeCup2 = _interopRequireDefault(_coffeeCup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  Footer.prototype.render = function render() {
	    var data = this.props.info;
	
	    return _react2.default.createElement(
	      'footer',
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'social-networks' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'http://phanorcoll.deviantart.com/',
	                className: 'a-animation'
	              },
	              'deviantart'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://twitter.com/phanor/', className: 'a-animation' },
	              'twitter'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/phanorcoll', className: 'a-animation' },
	              'github'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.linkedin.com/in/phanorcoll/',
	                className: 'a-animation'
	              },
	              'linkedin'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'copyright' },
	          _react2.default.createElement(
	            'div',
	            null,
	            '\xA9 2018 \xA0',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://twitter.com/phanor', className: 'a-animation' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                data.site.siteMetadata.author
	              )
	            ),
	            '. All Rights Reserved.'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Made with lots of',
	            _react2.default.createElement('img', { src: _coffeeCup2.default, alt: data.site.siteMetadata.author }),
	            ' on',
	            _react2.default.createElement('img', { src: _linuxLogo2.default, alt: data.site.siteMetadata.author }),
	            ' using \xA0',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.gatsbyjs.org/', className: 'a-animation' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Gatsbyjs'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _phanorcollLogo = __webpack_require__(665);
	
	var _phanorcollLogo2 = _interopRequireDefault(_phanorcollLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var siteTitle = _ref.siteTitle;
	  return _react2.default.createElement(
	    'header',
	    { className: 'header' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/', className: 'logo' },
	      _react2.default.createElement('img', { src: _phanorcollLogo2.default, alt: 'Phanor Coll' })
	    ),
	    _react2.default.createElement('input', { className: 'menu-btn', type: 'checkbox', id: 'menu-btn' }),
	    _react2.default.createElement(
	      'label',
	      { className: 'menu-icon', htmlFor: 'menu-btn' },
	      _react2.default.createElement('span', { className: 'navicon' })
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'menu' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Home'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/about', activeClassName: 'active' },
	          'About'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/lab', activeClassName: 'active' },
	          'lab'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/library', activeClassName: 'active' },
	          'Library'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/hands-on-gatsbyjs', activeClassName: 'active' },
	          'Gatsbyjs'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/contact', activeClassName: 'active' },
	          'contact'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/linux-logo.674df11b.svg";

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _header = __webpack_require__(309);
	
	var _header2 = _interopRequireDefault(_header);
	
	__webpack_require__(554);
	
	__webpack_require__(412);
	
	var _Footer = __webpack_require__(105);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: data.site.siteMetadata.title,
	        meta: [{
	          name: 'description',
	          content: data.site.siteMetadata.description
	        }, {
	          name: 'keywords',
	          content: 'fullstack, developer, frontend, projects, go, reactjs, javascript, docker, es6, neo4j, dgraph, golang'
	        }, {
	          name: 'Cache-control',
	          content: 'public, max-age=691200'
	        }]
	      },
	      _react2.default.createElement('link', {
	        rel: 'stylesheet',
	        href: 'https://cdn.jsdelivr.net/npm/animate.css@3.5.2/animate.min.css'
	      })
	    ),
	    _react2.default.createElement(_header2.default, { siteTitle: data.site.siteMetadata.title }),
	    _react2.default.createElement(
	      'div',
	      null,
	      children()
	    ),
	    _react2.default.createElement(_Footer2.default, { info: data })
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-8a9c58a4764c13d6130e.js